import { useState, useEffect, useCallback } from 'react';
import { getCategoriesWithProducts } from '../services/Products/ProductServices';

const useCategories = (productsPerCategory = 4) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategoriesWithProducts = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getCategoriesWithProducts(productsPerCategory);
            setCategories(data || []);
        } catch (err) {
            setError(err.message || 'Failed to fetch categories');
            setCategories([]);
        } finally {
            setLoading(false);
        }
    }, [productsPerCategory]);

    useEffect(() => {
        fetchCategoriesWithProducts();
    }, [fetchCategoriesWithProducts]);

    const refetch = async () => {
        await fetchCategoriesWithProducts();
    };

    return {
        categories,
        loading,
        error,
        refetch
    };
};


export default useCategories;
